module.exports = __webpack_public_path__ + "static/media/Download.72231ed1.svg";